import { useEffect, useState } from 'react';

type Props = {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => void;
};

export function useLoadMoreOnVisible({ hasNextPage, isFetchingNextPage, fetchNextPage }: Props) {
    const [sentinel, setSentinel] = useState<HTMLElement | null>(null);

    // Re-observing after every fetch makes the observer report the sentinel's current state again,
    // so a sentinel still in view after a page lands triggers the next page instead of stalling.
    useEffect(() => {
        if (!sentinel || !hasNextPage || isFetchingNextPage) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) fetchNextPage();
        });
        observer.observe(sentinel);

        return () => observer.disconnect();
    }, [sentinel, hasNextPage, isFetchingNextPage, fetchNextPage]);

    return setSentinel;
}
